import { useContext, useReducer } from 'react'
import { Outlet } from 'react-router-dom'
import { mineralReducer } from './mineralReducer'
import { mineralInitialState } from './mineralInitialState'
import MineralContext from './MineralContext'

export const useMineralContext = () => useContext(MineralContext)

export function MineralProvider() {
  const [mineralState, mineralDispatch] = useReducer(
    mineralReducer,
    mineralInitialState,
  )

  return (
    <MineralContext.Provider value={{ mineralState, mineralDispatch }}>
      <Outlet />
    </MineralContext.Provider>
  )
}
